import React from 'react'
import ArticleLayout from '../../components/article-layout/article-layout.component'
import { getClient } from '../../client'
import { groqListingBySlugQuery, groqListingPathsQuery } from '../../lib/libFunctions'
import { buildLocalBusiness, buildBreadcrumb } from '../../lib/structuredData'
import { siteUrl } from '../../lib/companyInfo'
import approvedListingLocations from '../../lib/approved-listing-locations.cjs'

export default function EatDrinkListing({ listing }) {
  const url = `${siteUrl}/eat-drink/${listing.slug.current}`
  const jsonLd = [
    buildLocalBusiness(listing, url),
    buildBreadcrumb('Eat & Drink', `/eat-drink/${listing.slug.current}`),
  ]
  return <ArticleLayout doc={listing} seo={listing.seo} jsonLd={jsonLd} variant="business" />
}

export async function getStaticPaths() {
  const all = await getClient().fetch(groqListingPathsQuery())
  const paths = all
    .filter((l) => l.slug && l.sectionPage === 'Eat & Drink')
    .map((l) => ({ params: { slug: l.slug } }))
  return { paths, fallback: 'blocking' }
}

export async function getStaticProps({ params }) {
  const listing = await getClient().fetch(groqListingBySlugQuery(params.slug))
  if (!listing) return { notFound: true }
  return { props: { listing: approvedListingLocations.applyApprovedListingLocation(listing) }, revalidate: 60 }
}
